let i = 0

export default () => {
    return i++ // eslint-disable-line no-plusplus
}
